<template>
	<div v-if="user && !donot">
		<div style="padding: 10px">
			<router-view />
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex"
import { goto } from "@/utils/utils"

export default {
	name: "ticketing-layout",
	computed: {
		...mapGetters({
			user: "user/user",
			organizationModules: "organization/modules"
		})
	},
	data() {
		return {
			donot: true
		}
	},
	created() {
		//NON PUÒ visualizzare ticketing
		if (this.organizationModules.length == 3) {
			this.goto("/dashboard")
		} else this.donot = false
	},
	methods: {
		goto
	}
}
</script>
